import { extractClubCodeFromPath } from '@/utils/fetchCurrentUser.js';

function getPathname() {
  if (typeof window === 'undefined') return '';
  try {
    return window.location?.pathname || '';
  } catch {
    return '';
  }
}

export function isClubRoutePath(pathname = getPathname()) {
  const code = extractClubCodeFromPath(pathname);
  return Boolean(code);
}

function readStoredRoles() {
  if (typeof window === 'undefined') {
    return { platformRole: null, normalizedRoles: [], hasDeveloperAccess: undefined };
  }
  const platformRole = window.__PRIVANA_PLATFORM_ROLE__ ?? null;
  const normalizedRoles = Array.isArray(window.__PRIVANA_NORMALIZED_ROLES__)
    ? window.__PRIVANA_NORMALIZED_ROLES__
    : [];
  const hasDeveloperAccess = window.__PRIVANA_HAS_DEVELOPER_ACCESS__;
  return { platformRole, normalizedRoles, hasDeveloperAccess };
}

export function storePlatformRoleHints({ platformRole = null, normalizedRoles = [], hasDeveloperAccess } = {}) {
  if (typeof window === 'undefined') return;
  if (platformRole !== undefined) {
    window.__PRIVANA_PLATFORM_ROLE__ = platformRole;
  }
  if (Array.isArray(normalizedRoles)) {
    window.__PRIVANA_NORMALIZED_ROLES__ = normalizedRoles;
  }
  if (hasDeveloperAccess !== undefined) {
    window.__PRIVANA_HAS_DEVELOPER_ACCESS__ = Boolean(hasDeveloperAccess);
  }
}

export function shouldSkipPlatformProfile(pathname = getPathname()) {
  if (!isClubRoutePath(pathname)) return false;
  return true;
}

export function getPlatformRoleHints() {
  return readStoredRoles();
}
